function getPropRoot(name) {
  return document
    .querySelector(`.product-option[data-prop-name=${name}]`)
    .closest('.product-options__items')
}

function getPropItemList(name) {
  return document.querySelectorAll(`.product-option[data-prop-name=${name}]`)
}

function toggleProp(name, value) {
  getPropRoot(name).dataset.value = value
  getPropItemList(name).forEach((item) => {
    const { propValue } = item.dataset
    if (propValue.toUpperCase() === value.toUpperCase()) {
      item.classList.add('is-active')
    } else {
      item.classList.remove('is-active')
    }
  })
}

function propClickHandler(event) {
  event.preventDefault()
  const propNode = event.target.closest('.product-option')
  const { propName, propValue } = propNode.dataset
  toggleProp(propName, propValue)
}

export function productPropsStart(root) {
  const allProp = new Set()
  root.querySelectorAll('.product-option[data-prop-name]').forEach((item) => {
    allProp.add(item.dataset.propName)
    item.addEventListener('click', propClickHandler)
  })

  for (const propName of allProp) {
    const propItems = getPropItemList(propName)
    if (propItems.length > 0) {
      const { propValue } = propItems[0].dataset
      getPropRoot(propName).dataset.name = propName
      toggleProp(propName, propValue)
    }
  }
}
